import { Component, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DetailsElementData } from '../Details';
import { PasfotoComponent } from '../../shared/components/pasfoto/pasfoto.component';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-detail-panel',
	templateUrl: './detail-panel.component.html',
	styleUrls: ['./detail-panel.component.scss'],
	imports: [PasfotoComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailPanelComponent {
	detailsData = input<DetailsElementData | undefined>(undefined);
	type = input.required<string>();
	showNext = input.required<boolean>();
	showPrevious = input.required<boolean>();

	@Output()
	changeElement: EventEmitter<boolean> = new EventEmitter<boolean>();
}
